import { createFileRoute, redirect } from '@tanstack/react-router'
import { pageTitle } from '@/lib/page-title'
import { adminSessionQueryOptions } from '@/query/query-options'
import { AdminHome } from './-components/admin-home'

export const Route = createFileRoute('/(private)/')({
	head: ({ match }) => ({
		meta: [
			{
				title: pageTitle(
					match.context.appLanguage,
					'admin:home.page_title'
				)
			}
		]
	}),
	beforeLoad: async ({ context }) => {
		// The parent (private) guard has already fetched the session; this only reads the cache.
		const session = await context.queryClient.ensureQueryData(
			adminSessionQueryOptions()
		)
		// A facility manager starts from its residences: the data the call is written from.
		if (
			session.sessionType === 'authenticated' &&
			session.admin.role === 'facility_manager'
		) {
			throw redirect({ to: '/strutture', replace: true })
		}
	},
	component: AdminHome,
	staticData: {
		breadcrumb: 'admin:home.page_title'
	}
})
